// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__kAvT9","container":"styles_container__eBH3O","title":"styles_title__1d5fx","wrapper":"styles_wrapper__2SKcH","answer":"styles_answer__fb_3D"};